import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  list: {
    margin: [theme.spacing(4), 0],
    padding: [0, theme.spacing(4)],
    width: '100%',
    boxShadow: '0px 2px 0px rgba(50, 50, 71, 0.06)',
  },
  item: {
    color: theme.palette.colors.black,
    minWidth: 'unset',
    marginRight: theme.spacing(4),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/DesktopNavTabs/useStyles.js